import { useLazyQuery } from '@apollo/client';
import { parse as parseCookies } from 'cookie';
import { useEffect } from 'react';
import { v4 as uuid } from 'uuid';

import { useAppConfig } from 'src/components/App/useAppConfig';
import { GetJobDetailsDocument } from 'src/graphql/graphql';

import { useLocale } from '../useLocale';
import { useTimezone } from '../useTimezone';
import { useZoneFeature } from '../useZoneFeature';

const useFetchJobDetails = (jobId: string) => {
  const { language, zone, country } = useAppConfig();
  const includeDisplayTags = useZoneFeature('SHOW_JOB_DISPLAY_TAGS');
  const locale = useLocale();
  const { JobseekerSessionId: sessionId } = parseCookies(
    window.document.cookie,
  );

  const timezone = useTimezone();

  const [fetchJobDetails, { data, loading, error, refetch }] = useLazyQuery(
    GetJobDetailsDocument,
    {
      fetchPolicy: 'no-cache',
    },
  );

  useEffect(() => {
    fetchJobDetails({
      variables: {
        jobId,
        jobDetailsViewedCorrelationId: uuid(),
        sessionId: sessionId ?? '',
        zone,
        locale,
        languageCode: language,
        countryCode: country,
        timezone,
        includeDisplayTags,
      },
    });
  }, [
    fetchJobDetails,
    jobId,
    sessionId,
    zone,
    locale,
    language,
    country,
    timezone,
    includeDisplayTags,
  ]);

  return {
    error,
    isLoading: loading,
    jobDetails: data?.jobDetails,
    onReloadClick: refetch,
  };
};

export default useFetchJobDetails;
